// Client-side lint for prompt-template [[parameter]] syntax. Mirrors the backend rule
// (PromptTemplatingServiceSuperpower): parameter names must be lowercase snake_case
// (a-z, 0-9, _). The backend re-validates on save, but catching it here gives the user an
// immediate, actionable message instead of a failed request.

const VALID_PARAM = /^[a-z0-9_]+$/;
const TOKEN = /\[\[([^[\]]*)\]\]/g;

// Best-effort camelCase / "Foo Bar" / "foo-bar" -> snake_case for the "did you mean" hint.
export function toSnakeCase(name) {
  let out = "";
  for (const ch of name) {
    if (ch >= "A" && ch <= "Z") {
      if (out.length && out[out.length - 1] !== "_") out += "_";
      out += ch.toLowerCase();
    } else if (ch === " " || ch === "-") {
      if (out.length && out[out.length - 1] !== "_") out += "_";
    } else {
      out += ch;
    }
  }
  return out;
}

// Comments are ignored by the parser, so a [[Token]] inside one is harmless — strip them
// first to avoid false positives that would wrongly block a valid template.
function stripComments(text) {
  return text.replace(/\/\*[\s\S]*?\*\//g, "").replace(/\/\/[^\n]*/g, "");
}

// Returns a friendly error string, or null when the template's tokens are all valid.
export function validateTemplateTokens(text) {
  if (!text) return null;
  const stripped = stripComments(text);
  let match;
  TOKEN.lastIndex = 0;
  while ((match = TOKEN.exec(stripped)) !== null) {
    const name = match[1];
    if (VALID_PARAM.test(name)) continue;
    const suggestion = toSnakeCase(name);
    const hint =
      suggestion && suggestion !== name && VALID_PARAM.test(suggestion)
        ? ` Did you mean [[${suggestion}]]?`
        : "";
    return `Parameter [[${name}]] is invalid: parameter names must be lowercase snake_case (a–z, 0–9, _).${hint}`;
  }
  return null;
}
